const KEY = "ptp.join.idempotencyKey";

/**
 * A stable key for this visitor's submission, persisted so it survives a reload.
 *
 * That is the point: if the phone loses signal mid-POST and the visitor retries, the
 * server recognizes the retry and returns the original submission instead of creating
 * a second particle.
 */
export function submissionIdempotencyKey(): string {
  try {
    const existing = localStorage.getItem(KEY);
    if (existing) return existing;
    const created = crypto.randomUUID();
    localStorage.setItem(KEY, created);
    return created;
  } catch {
    return crypto.randomUUID();
  }
}

/** Called after a successful release, so a later visitor on the same device starts fresh. */
export function clearIdempotencyKey(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {
    // Storage unavailable; the server-side constraints still hold.
  }
}
